import React from "react"
import PPPictureBoxLoad from "../pricetable/PPPictureBoxLoad"

export default function PPMatchingProductImage({ imageUrl, className }) {
    return (
        <div className={"pp-matching-product-img-wrap " + (className || "")}>
            {imageUrl ? (
                <PPPictureBoxLoad image={imageUrl} className="pp-matching-product-img" />
            ) : (
                <div className="pp-matching-product-img pp-matching-product-img--empty">
                    <i className="far fa-image" />
                </div>
            )}
        </div>
    )
}
